import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { LocationState } from '../slices/locations';

export const locationsSelector: (state: RootState) => LocationState = (
  state: RootState,
) => state.locations;

export const routingLocationsSelector = createSelector(
  locationsSelector,
  (locations) => {
    return locations.routingLocations;
  },
);
